import React, { Suspense, useState } from 'react'
import { Container, Content } from 'rsuite'
import { Outlet } from 'react-router'
import { Header, Footer, SideNav, SectionLoader } from '../shared'
import MfaGraceBanner from '../pages/mfaSetup/MfaGraceBanner'
import { useClosePickersOnScroll } from '../hooks/useClosePickersOnScroll'

const AuthLayout: React.FC = () => {
  useClosePickersOnScroll()

  // Off-canvas nav state — only meaningful on phones. On desktop the sidebar
  // is always visible and this flag is ignored by the CSS. Toggled by the
  // header hamburger; closed on overlay tap or when a nav item is selected.
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <Container className="layout">
      <Header onMenuToggle={() => setMobileNavOpen((open) => !open)} />
      <MfaGraceBanner />
      <Container>
        <SideNav
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        {/* Dimmed backdrop behind the slide-in nav on phones. */}
        <button
          type="button"
          aria-label="Close menu"
          className={`layout__nav-overlay${
            mobileNavOpen ? ' layout__nav-overlay--visible' : ''
          }`}
          onClick={() => setMobileNavOpen(false)}
        />
        <Content className="content">
          <Suspense fallback={<SectionLoader />}>
            <Outlet />
          </Suspense>
        </Content>
      </Container>
      <Footer />
    </Container>
  )
}

export default AuthLayout
